
export const CAR_SIZES = [
   'SMALL',
   'COMPACT',
   'MEDIUM',
   'LARGE',
   'UNKNOWN'
];

export const FUEL_TYPES = [
   'PETROL',
   'DIESEL',
   'HYBRID',
   'PLUGIN_HYBRID',
   'ELECTRIC'
]

export const buildAnswerObject = (
    {
       adults, children, diet, energy, currency,
       isRenewableEnergy, driving, carSize, carFuel,
       waste, shortFlights, quickFlights, intermediateFlights, longFlights,
       countryCode, storedCountryCode
    }
) => {

   const HOUSEHOLD = generateHousehold(adults, children);
   const DIET = generateDiet(diet);
   const ENERGY = generateEnergy(energy, currency, isRenewableEnergy);
   const DRIVING = generateDriving(driving, carSize, carFuel);
   const WASTE = generateWaste(waste);
   const FLIGHTS = generateFlights(shortFlights, quickFlights, intermediateFlights, longFlights);
   const UNAVOIDABLE = generateUnavoidable(adults, children);

   return {
      ...HOUSEHOLD,
      ...DIET,
      ...ENERGY,
      ...DRIVING,
      ...WASTE,
      ...FLIGHTS,
      ...UNAVOIDABLE,
      footprintDataRegionCode: typeof countryCode === 'string' ? countryCode : 'nz',
      userCountryCode: typeof storedCountryCode === 'string' ? storedCountryCode : 'nz',
      schemaVersion: 3
   }
}

export const generateHousehold = (adults, children) => {
   return {
      HOUSEHOLD: {
         adults: Number(adults) >= 1 ? Number(adults) : 1,
         children: Number(children) >= 0 ? Number(children) : 0
      }
   };
}

export const generateUnavoidable= (adults, children) => {
   return {UNAVOIDABLE: {unavoidableCountryEmissions: Number(adults + children) >= 1 ? adults + children : 1}};
}

export const generateWaste = (waste) => {
   return {
      WASTE: {
         yearlyProducedOneAdult: {
            value: Number(waste) >= 0 ? Number(waste) : 0,
            unit: 'KG'
         }
      }
   };
}

export const generateDiet = (diet) => {
   return {
      DIET: {
         yearlyCarbonFootprintOneAdult: {
            value: Number(diet) >= 0 ? Number(diet) : 0,
            unit: 'T'
         }
      }
   };
}

export const generateFlights = (numShortFlights, numQuickFlights, numIntermediateFlights, numLongFlights) => {
   return {
      FLIGHTS: {
         numShort: Number(numShortFlights) >= 0 ? Number(numShortFlights) : 0,
         numQuick: Number(numQuickFlights) >= 0 ? Number(numQuickFlights) : 0,
         numIntermediate: Number(numIntermediateFlights) >= 0 ? Number(numIntermediateFlights) : 0,
         numLong: Number(numLongFlights) >= 0 ? Number(numLongFlights) : 0
      }
   };
}

export const generateDriving = (yearlyDistance, carSize, carFuel) => {
   return {
      DRIVING: [
         {
            size: CAR_SIZES.includes(carSize) ? carSize : CAR_SIZES[2],
            fuel: FUEL_TYPES.includes(carFuel) ? carFuel : FUEL_TYPES[0],
            type: 'CAR',
            yearlyDistance: {
               value: Number(yearlyDistance) >= 0 ? Number(yearlyDistance) : 0,
               unit: 'KM'
            }
         }
      ]
   };
}

export const generateEnergy = (value, currency, isRenewableEnergy) => {
   return {
      ENERGY: {
         monthlySpend: {
            value: Number(value) >= 0 ? Number(value) : 0,
            currency: typeof currency == 'string' ? currency.length <= 3 ? currency : 'NZD' : 'NZD'
         },
         hasCarbonNeutralEnergy: Boolean(isRenewableEnergy)
      }
   };
}
